"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _playlist = require("../playlist");

var _playlistParser = require("../parsers/playlist/playlist-parser");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var url = require('url');

var Rendition =
/*#__PURE__*/
function () {
  function Rendition(renditionInfo) {
    _classCallCheck(this, Rendition);

    (0, _playlistParser.configureRendition)(this, renditionInfo);
  }

  _createClass(Rendition, [{
    key: "fetch",
    value: function fetch() {
      return _playlist.Playlist.fetch(this.url);
    }
  }, {
    key: "url",
    get: function get() {
      if (this.uri.slice(0, 4) === 'http') {
        return this.uri;
      } else {
        if (this.basePath) {
          return url.parse([this.basePath, this.uri].join('/')).href;
        } else {
          return undefined;
        }
      }
    }
  }]);

  return Rendition;
}();

var _default = Rendition;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/playlists/rendition.js
// module id = 481
// module chunks = 0